/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Re_AttendedInputs */

const cs_enum_re_attended = /** @type {(inputs: Enum_Re_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opakovaná účast`)
};

const en_enum_re_attended = /** @type {(inputs: Enum_Re_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-attended`)
};

/**
* | output |
* | --- |
* | "Re-attended" |
*
* @param {Enum_Re_AttendedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_re_attended = /** @type {((inputs?: Enum_Re_AttendedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Re_AttendedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_re_attended(inputs)
	return cs_enum_re_attended(inputs)
});